import { render } from "./DepartmentsTab.vue?vue&type=template&id=0f5e759e&scoped=true"
import script from "./DepartmentsTab.vue?vue&type=script&lang=js"
export * from "./DepartmentsTab.vue?vue&type=script&lang=js"

import "./DepartmentsTab.vue?vue&type=style&index=0&id=0f5e759e&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5e759e"]])

export default __exports__